<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Transferências Bancárias</h3>
        </div>
        <!-- Filter -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Transferências</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 v-if="pagination.TotalItems > 0" class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0" v-if="pagination.TotalItems > 0">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div
                      class="dropdown-menu"
                      id="dropTableOptions"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : ''"
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader
                            :small="true"
                            :isLoading="loadingReport"
                          ></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelMerchant }}
                    </th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelNameMerchant }}
                    </th>
                    <th scope="col" class="border-0">
                      {{ labelTransferType }}
                    </th>
                    <th scope="col" class="border-0">
                      {{ labelReceiverName }}
                    </th>
                    <th scope="col" class="border-0">{{ labelAmount }}</th>
                    <th scope="col" class="border-0">
                      {{ labelIsReleaseTransfer }}
                    </th>
                    <th scope="col" class="border-0">
                      {{ labelIsTransferred }}
                    </th>
                    <th scope="col" class="border-0">
                      {{ labelCompensationDate }}
                    </th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(transfer, index) in transfersRegister"
                    :key="index"
                  >
                    <td></td>
                    <td class="text-left">{{ transfer.Merchant.Id }}</td>
                     <td class="text-left td-with-subs">
                      <div>{{ transfer.Merchant.Name | substring(50) }}</div>
                      <span>{{ transfer.Merchant.Identity | identity }}</span>
                    </td>
                    <td>{{ transfer.TransferType.Name }}</td>
                    <td class="text-left td-with-subs">
                      <div>{{ transfer.ReceiverName | substring(50) }}</div>
                      <span>{{ transfer.Identity | identity }}</span>
                    </td>
                    <td>{{ transfer.Amount | currency }}</td>
                    <td v-if="transfer.IsReleaseTransfer"><i class="fas fa-check fa-green" /></td>
                    <td v-else><i class="fas fa-times fa-red" /></td>
                    <td v-if="transfer.IsTransferred"><i class="fas fa-check fa-green" /></td>
                    <td v-else><i class="fas fa-times fa-red" /></td>
                    <td>{{ transfer.CompensationDate | date }}</td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a 
                            v-if="$isAuthorize('TransferRegister', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenTransferRegister($event, transfer.Id, true)">
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a 
                            class="dropdown-item"
                            href="#"
                            v-if="transfer.Merchant.Id == 35 && $isAuthorize('TransferRegister', 'Update')" 
                            v-on:click="OpenTransferRegister($event, transfer.Id)">
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>

                          <a
                            v-if="$isAuthorize('TransferRegister', 'Get')"
                            class="dropdown-item"
                            href="#"
                            :class="loadingDownload ? 'disabled' : ''"
                            v-on:click.stop="GetTransferRegister(transfer.Id, true)"
                          >
                            <template v-if="loadingDownload">
                              <loader
                                :small="true"
                                :isLoading="loadingDownload"
                              ></loader>
                            </template>
                            <template v-else>
                              <i class="fas fa-long-arrow-alt-down mr-2"></i>
                              Download
                            </template>
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      transfersRegister == null ||
                      transfersRegister == undefined ||
                      transfersRegister.length == 0
                    "
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            class="form-control"
            placeholder="IdMerchant"
            type="text"
            v-model="filter.IdMerchant"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IdTransferType" :value="null">
            <option :value="null" selected>{{ labelTransferType }}</option>
            <option
              v-for="type in transferTypes"
              v-bind:key="type.Code"
              v-bind:value="type.Code"
            >
              {{ type.Name }}
            </option>
          </d-select>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            :placeholder="labelReceiverName"
            type="text"
            class="form-control"
            v-model="filter.ReceiverName"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <the-mask
            class="form-control"
            type="tel"
            :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.Identity"
            placeholder="CPF/CNPJ"
            v-on:keyup.enter.native="Filter()"
          />
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IsTransferred" :value="null">
            <option :value="null">Selecione</option>
            <option :value="true">Transferido</option>
            <option :value="false">Não transferido</option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IsReleaseTransfer" :value="null">
            <option :value="null">Selecione</option>
            <option :value="true">Liberado</option>
            <option :value="false">Não liberado</option>
          </d-select>
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      size="lg"
      id="mFormTransferRegister"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <template v-slot:modal-header>
        <h5 class="col-10 no-gutters mb-0">
          {{ modalTitle }}
        </h5>
        <button class="close" @click="HideModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <loader :is-loading="loadingList"></loader>

      <ValidationObserver tag="form">
        <div v-if="!loadingList">
          <d-form-row>
            <!-- Nome -->
            <d-col md="6" class="form-group float-right">
              <label>{{ labelMerchant }}</label>
              <d-form-input 
                type="text" 
                :disabled="isSeeing" 
                v-model="transfer.Merchant.Id"
                readonly
              />
            </d-col>

            <d-col md="6" class="form-group">
              <label>{{ labelIdentity }}</label>
                <the-mask
                  class="form-control"
                  type="text"
                  :mask="['##.###.###/####-##']"
                  v-model="transfer.Merchant.Identity"
                  :disabled="isSeeing"
                  readonly
                />
            </d-col>
          </d-form-row>
          <d-form-row>
            <!-- Receiver Name -->
            <d-col md="6" class="form-group float-right">
              <label>{{ labelReceiverName }}</label>
              <d-form-input
                type="text"
                v-model="transfer.ReceiverName"
                :disabled="isSeeing"
                readonly
              />
            </d-col>

            <!-- CNPJ -->
            <d-col md="6" class="form-group">
              <label>{{ labelIdentity }}</label>
                <the-mask
                  class="form-control"
                  type="text"
                  :mask="['##.###.###/####-##']"
                  v-model="transfer.Identity"
                  :disabled="isSeeing"
                />
            </d-col>

          </d-form-row>
          <d-form-row>     
            <!-- Identification -->
            <d-col class="col-4">
              <label>{{ labelIdentification }}</label>
              <d-form-input
                type="text"
                v-model="transfer.Identification"
                :disabled="isSeeing"
                readonly
              />
            </d-col> 

            <!-- Tipo Transferência -->
            <d-col class="col-4">
              <label>{{ labelTransferType }}</label>
              <d-form-input
                type="text"
                v-model="transfer.TransferType.Name"
                :disabled="isSeeing"
                readonly
              />
            </d-col>

            <!-- Amount -->
            <d-col class="col-4">
              <label>{{ labelAmount }}</label>
              <currency-input
                class="form-control"
                v-model="transfer.Amount"
                :disabled="isSeeing"
              />
            </d-col>
          </d-form-row>
          <d-form-row>
            <!-- IsTransferred -->
            <d-col class="col-3">
              <div class="form-group">
                <br/>
                <d-checkbox
                  v-model="transfer.IsTransferred"
                  :disabled="true">
                  Transferido?
                </d-checkbox>
              </div>
            </d-col>
          </d-form-row>
          <d-form-row>
            <!-- Created Date  -->
            <d-col md="4" class="form-group">
              <label>{{ labelCreatedDate }}</label>
              <d-form-input
                type="text"
                v-bind:value="transfer.CreatedDate | date('DD/MM/YYYY - HH:mm')"
                readonly
              />
            </d-col>
            <!-- Compensation Date -->
            <d-col md="4" class="form-group">
              <label>{{ labelCompensationDate }}</label>
              <d-form-input
                type="text"
                v-bind:value="transfer.CompensationDate | date('DD/MM/YYYY - HH:mm')"
                readonly
              />
            </d-col>
            <d-col md="4" class="form-group">
              <label>{{ labelStatusPayment }}</label>
              <d-form-input
                type="text"
                v-bind:value="transfer.Validation"
                readonly
              />
            </d-col>
          </d-form-row>
          <h4>Dados do banco</h4>
          <hr />
          <d-form-row>
            <!-- Bank (agência) -->
            <d-col md="3" class="form-group float-right">
              <label>Código do Banco</label>
              <d-form-input 
                type="text" 
                :disabled="isSeeing" 
                v-model="transfer.BankData.Bank.Code"
                />
            </d-col>

            <d-col md="6" class="form-group float-right">
              <label>Nome do Banco</label>
              <d-form-input 
                type="text" 
                :disabled="isSeeing" 
                v-model="transfer.BankData.Bank.Name"
                readonly/>
            </d-col>

            <d-col md="3" class="form-group float-right">
              <label>Tipo de Conta</label>
              <d-form-input 
                type="text" 
                :disabled="isSeeing" 
                v-model="transfer.AccountType.Name"
                readonly/>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="3" class="form-group float-right">
              <label>Conta</label>
              <d-form-input 
                type="text" 
                :disabled="isSeeing" 
                v-model="transfer.BankData.BankAccount"/>
            </d-col>

            <d-col md="3" class="form-group float-right" v-if="transfer.BankData.BankAccountDigit != null">
              <label>Dígito</label>
              <d-form-input 
                type="text" 
                :disabled="isSeeing" 
                v-model="transfer.BankData.BankAccountDigit"/>
            </d-col>

            <d-col md="3" class="form-group float-right">
              <label>Agência</label>
              <d-form-input 
                type="text" 
                :disabled="isSeeing" 
                v-model="transfer.BankData.BankAgency"/>
            </d-col>

            <d-col md="3" class="form-group float-right">
              <label>Dígito</label>
              <d-form-input 
                type="text" 
                :disabled="isSeeing" 
                v-model="transfer.BankData.BankAgencyDigit"/>
            </d-col>
          </d-form-row>
        </div>
      </ValidationObserver>

      <template slot="modal-footer">
        <b-button-group>
          <b-button
            type="button"
            class="btn btn-success"
            :disabled="loadingUpdate || isSeeing"
            v-on:click="UpdateTransferRegister()"
          >
            <template v-if="!loadingUpdate">{{"Salvar alterações"}}</template>
            <template v-else>
              <loader :small="true" :isLoading="loadingUpdate"></loader>
            </template>
          </b-button>
        </b-button-group>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
export default {
  name: "transferRegister",
  components: {},
  data: function () {
    return {
      filter: {
        IdMerchant: null,
        IdTransferType: null,
        ReceiverName: null,
        Identity: null,
        IsTransferred: null,
        IsReleaseTransfer: null,
      },
      transfersRegister: [],
      transferTypes: [],
      transfer: {
        Merchant: {
          Name: null,
          Identity: null,
        },
        BankData: { 
          Bank: {
            Code: null,
          }
        },
        TransferType: {
          Name: null,
        },
        AccountType: {
          Name: null,
        }
      },

      countFilter: 0,

      modalTitle: "Detalhe da Transferência Bancária",
      labelMerchant: "Id Merchant",
      labelNameMerchant: "Empresa Solicitante",
      labelTransferType: "Tipo de Transferência",
      labelReceiverName: "Destinatário",
      labelAmount: "Valor",
      labelIsReleaseTransfer: "Liberado",
      labelIsTransferred: "Transferido",
      labelIdentity: "CPF/CNPJ",
      labelCreatedDate: "Data de Criação",
      labelCompensationDate: "Data de Compensação",
      labelIdentification: "Identificação",
      labelStatusPayment: "Status do Pagamento", 

      isSeeing: false,
      listPending: false,
      loadingReport: false,
      loadingDownload: false,
      loadingList: false,
      loadingModal: false,
      loadingTransferRegister: false,
      loadingUpdate: false,

      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
    };
  },
  watch: {
    "pagination.PageNumber": function () {
      this.ListTransferRegister();
    },
    "pagination.RowsPerPage": function () {
      this.ListTransferRegister();
    },
  },
  mounted() {
    this.ListTransferRegister();
    this.ListTransferType();
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    HideModal: function () {
      this.$bvModal.hide("mFormTransferRegister");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListTransferRegister();
    },
    ResetFilter: function () {
      this.filter = {
        IdMerchant: null,
        IdTransferType: null,
        ReceiverName: null,
        Identity: null,
        IsTransferred: null,
        IsReleaseTransfer: null,
      };
      this.ListTransferRegister();
    },
    ListTransferType: function () {
      this.$store
        .dispatch("ListTransferType")
        .then((response) => {
          this.transferTypes = response;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao obter lista de tipos de transferências",
            error
          );
        });
    },
    ListTransferRegister: function () {
      this.countFilter = 0;

      if (hasValue(this.filter.IdMerchant)) this.countFilter++;
      if (hasValue(this.filter.IdTransferType)) this.countFilter++;
      if (hasValue(this.filter.ReceiverName)) this.countFilter++;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      if (hasValue(this.filter.IsTransferred)) this.countFilter++;
      if (hasValue(this.filter.IsReleaseTransfer)) this.countFilter++;

      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.IdMerchant": this.filter.IdMerchant,
          "Object.TransferType.Id": this.filter.IdTransferType,
          "Object.ReceiverName": this.filter.ReceiverName,
          "Object.Identity": this.filter.Identity,
          "IsTransferred": this.filter.IsTransferred,
          "IsReleaseTransfer": this.filter.IsReleaseTransfer,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListTransferRegister", { params: data })
        .then(
          (response) => {
            this.transfersRegister = response.Objects;
            this.pagination.TotalItems = response.TotalItems;
          },
          (error) => {
            this.$makeToast(
              "Não foi possível as transferências bancárias",
              "danger",
              "Transferências bancárias",
              error
            );
          }
        )
        .finally(() => {
          this.loadingList = false;
        });
    },
    OpenTransferRegister: function (e, i, view) {
      e.preventDefault();

      if (view == undefined && i != undefined) {
        // Edit
        this.pOpened = i;
        this.isSeeing = false;
        this.modalTitle = "Editar";
        this.GetTransferRegister(i, false);
      } else {
        // View
        this.pOpened = i;
        this.isSeeing = true;
        this.modalTitle = "Detalhes";
        this.GetTransferRegister(i, false);
      }
      this.$bvModal.show("mFormTransferRegister");
    },
    GetTransferRegister: function (id, download) {
      this.loadingTransferRegister = true;
      this.$store
        .dispatch("GetTransferRegister", { id: id })
        .then((response) => {
          this.transfer = response;

          var titleComprovante = "Comprovante de ".concat(response.IsTransferred ? "Transferência" : ( response.IsReleaseTransfer ? "Agendamento" : ""))
          response.Url = "https://invoices.safe2pay.com.br/?".concat((response.IsTransferred ? "confirmation" : "Scheduling"), "=", (response.IsTransferred ?  response.HashConfirmation : response.HashScheduling));

          if (download && hasValue(response.Url)) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              titleComprovante
            );
            window.open(response.Url, "_blank");
          }
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao obter as informações da transferência bancária",
            error
          );
        })
        .finally(() => {
          this.loadingTransferRegister = false;
        });
    },
    UpdateTransferRegister: function () {
      this.loadingUpdate = true;

      this.$store
        .dispatch("UpdateTransferRegister", this.transfer)
        .then(() => {
          this.$makeToast(
            "Os dados da transferência bancária foram atualizados com sucesso",
            "success",
            "Atualizado"
          );
          this.ListTransferRegister();
          this.$bvModal.hide("mFormTransferRegister");
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao atualizar a transferência bancária " + this.transfer.Id + ".",
            error
          );
        })
        .finally(() => {
          this.loadingUpdate = false;
        });
    },
    GetParamsData: function (deletePagination = false) {
      let data = {
        ...this.pagination,
        ...{
          "Object.IdMerchant": this.filter.IdMerchant,
          "Object.TransferType.Id": this.filter.IdTransferType,
          "Object.ReceiverName": this.filter.ReceiverName,
          "Object.Identity": this.filter.Identity,
          "IsTransferred": this.filter.IsTransferred,
          "IsReleaseTransfer": this.filter.IsReleaseTransfer,
        },
      };
      delete data.TotalItems;
      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },
    GetReport: function (ev) {
      ev.preventDefault();
      this.loadingReport = true;
      let data = this.GetParamsData(true);
      this.$store
        .dispatch("ReportTransferRegister", { params: data })
        .then((response) => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
  },
};
</script>

<style scoped>
.fa-green {
  color: #0ac37f;
}
.fa-red {
  color: #ff0000;
}

.td-with-subs {
  display: block;
}
.td-with-subs > span {
  font-size: 10pt;
  opacity: 0.75;
}
.td-span-style {
  font-size: 9pt;
  opacity: 0.75;
}
.tr-hidden {
  border-top: hidden;
}
.fa-red {
  color: #ff0000;
}
.nav-steps .breadcrumb-item:before {
  content: none;
}
.nav-steps .breadcrumb-item .active {
  text-decoration: underline;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/transferRegister.vue